import { react, useState, useEffect } from 'react';
import HeaderSlogan from './HeaderSlogan';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';
import styles from './Home.module.css'; // Import css modules stylesheet as styles
import DonationTotals from './DonationTotals';
import PickupWizard from './PickupWizard/PickupWizard';
import AlertDialog from './Modals/AlertDialog';
import OutOfState from './Modals/OutOfState';
import NotInServiceArea from './Modals/NotInServiceArea';
import ActiveDonations from './Modals/ActiveDonations';
import TokenService from '../services/TokenService';
import Image from 'mui-image';
import Carousel from 'react-material-ui-carousel'
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Snackbar from '@mui/material/Snackbar';
import { Alert } from '@mui/material';
import { useSnackbar } from 'notistack';


import ReactGA from 'react-ga4';
import LinkedCharity from './PickupWizard/LinkedCharity';
ReactGA.initialize([{ trackingId: process.env.REACT_APP_GOOGLE_TAG }]);

const Home = (props) => {

    const [pickupWizardData, setpickupWizardData] = useState(null); // toggles the pickup wizard component
    const [zipCode, setZipCode] = useState('');
    const [formErrors, setFormErrors] = useState([]);
    const [loadingZipcode, setLoadingZipcode] = useState(false);
    const [showActiveDonationsDialog, setShowActiveDonationsDialog] = useState(false);
    const [snackbar, setSnackbar] = useState({
        message: '',
        severity: 'info'
    });
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    useEffect(() => {
        if (window.location.href.indexOf('localhost') == -1 && window.location.href.toLowerCase().indexOf('test.sipzee.com') == -1) {
            ReactGA.send({ hitType: "pageview", page: '/Pickup' });
        }
    }, []);

    const [alertDialog, setAlertDialog] = useState({
        show: false,
        title: '',
        message: '',
        closeButton: '',
    });

    function validateZip() {
        let errors = {};
        let hasErrors = false;

        if (zipCode.trim() == '') {
            errors["ZipCode"] = "Zipcode is required.";
            hasErrors = true;
        }
        else {
            if (isNaN(zipCode)) {
                // could be a short-code
            }
            else {
                // if its all numeric, make sure it's 5 characters in length
                if (zipCode.length !== 5) {
                    errors["ZipCode"] = "Only use a 5 digit zip code";
                    hasErrors = true;
                }
            }
            
        }

        setFormErrors(errors);

        if (!hasErrors) {
            // valid

            let queryParams = new URLSearchParams(window.location.search);
            let requestedRecycler = queryParams.get("recycler");

            var postData = {
                zipcode: zipCode,
                latitude: '',
                longitude: '',
                referrer: window.document.referrer,
                path: window.location.search,
                requestedRecycler: requestedRecycler,
                version:'2'
            }

            setLoadingZipcode(true);
            TokenService.post(postData, 'CheckZipcodeService', '')
                .then((response) => {

          

                    if (response !== null) {
                        setLoadingZipcode(false);
                        response = response[Object.keys(response)[0]];
                        if (response.Result === "SUCCESS") {
                            let jsonData = JSON.parse(response.JsonData);
                            if (typeof jsonData.ZipCodeInfo === 'string') {
                                jsonData.ZipCodeInfo = JSON.parse(jsonData.ZipCodeInfo);
                            }

                            if (typeof jsonData.Client === 'string') {
                                jsonData.Client = JSON.parse(jsonData.Client);
                            }

                            if (jsonData.Client.ClientId != 0) {
                                setpickupWizardData(jsonData);
                            }
                            else if (jsonData.ZipCodeInfo.StateAbbreviation !== "MI") {
                                setpickupWizardData(null);
                                setAlertDialog({
                                    show: true,
                                    title: 'Not in our service area',
                                    message: <OutOfState />,
                                    closeButton: 'Ok',
                                });
                            }
                            else if (jsonData.UserCount == 0) {
                                setpickupWizardData(null);
                                setAlertDialog({
                                    show: true,
                                    title: 'We are getting closer to ' + jsonData.ZipCodeInfo.City + ', but we are not there yet.',
                                    message: <NotInServiceArea />,
                                    closeButton: 'Close',
                                });
                            }
                            else {
                                setpickupWizardData(jsonData);
                            }
                        }
                    }
                })
                .catch((response) => {
                    enqueueSnackbar('Oops, something went wrong', {
                        variant: 'error',
                    });
                    if (response !== null) {
                        setLoadingZipcode(false);
                    }
                });
        }
    }

    function zipCodeKeyPress(e) {
        if (e.keyCode == 13) {
            validateZip();
        }
    }

    function showDonationOptions() {
        //setSnackbar({ message: 'Not yet implemented', severity : 'warning'});
        setShowActiveDonationsDialog(true);
    }

    function handleSnackBarClose() {
        setSnackbar({
            message: '', severity: ''
        });
    }

    try {
        console.log('document.referrer:' + window.document.referrer);
        console.log('window.location.search: ' + window.location.search);
    }
    catch {

    }

    return (

        <div>
    
            <LinkedCharity />
            <PickupWizard isShown={pickupWizardData !== null} pickupData={pickupWizardData} onCancel={() => setpickupWizardData(null)} />

            <div style={{ display: pickupWizardData !== null ? 'none' : 'block' }}>
                <HeaderSlogan />
                <Box display="flex"
                    justifyContent="center"
                    alignItems="center"

                    className={styles.header2}>
                    Recycle your cans & bottles from the comfort of your home using our mobile bottle deposit return service.
                </Box>

                <Box display="flex"
                    justifyContent="center"
                    alignItems="center"
                    noValidate
                    marginTop="30px"
                    autoComplete="off">
                    <Stack direction="column">
                        <Stack spacing={2} direction="row">
                            <TextField error={formErrors['ZipCode'] !== undefined} label="Zip code" onChange={(e) => setZipCode(e.target.value)} onKeyDown={zipCodeKeyPress} value={zipCode} variant="outlined" style={{ maxWidth: '175px' }} />
                            <LoadingButton loading={loadingZipcode} loadingIndicator="Loading" variant="contained" color="sipzeeYellow" style={{ fontWeight: 'bold' }} onClick={validateZip}>Get Started</LoadingButton>
                        </Stack>
                        <div className='FormFieldErrorDescription' style={{ textAlign: 'left' }}> {formErrors["ZipCode"]}</div>
                    </Stack>
                </Box>


                <div style={{ fontSize: '13pt', fontStyle: 'italic', fontWeight: 'bold', padding: '5px 0 0 0', textAlign: 'center' }}>No need to register or create an account</div>
                <div className={styles.card}>
                    <div style={{ paddingBottom: '10px', paddingTop: '10px', backgroundColor: 'var(--sipzee-gray-3)' }}>

                        <DonationTotals />
                        <div style={{ textAlign: 'center ', marginTop: '5px' }}>
                            <LoadingButton loadingIndicator="Loading" variant="contained" color="primary" style={{ fontWeight: 'bold', marginTop: '5px' }} onClick={showDonationOptions}>
                                Donation Options
                            </LoadingButton>
                        </div>


                    </div>
                </div>

                <div className={styles.card}>
                    <Carousel height={235} autoPlay={false} style={{ marginTop: '20px' }} indicatorContainerProps={{ className: styles.carouselIndicators }} >
                        <div style={{ backgroundColor: 'var(--sipzee-green-3)', height: '100%', paddingBottom: '10px' }}>

                            <div className={styles.CarouselHeader}>1. Value Your Returnables </div>
                            <div className={styles.CarouselDescription}>
                                You can count your cans & bottles, or if you don't want to get your hands dirty, simply use our quick estimator to value your returnables.
                            </div>
                        </div>
                        <div style={{ backgroundColor: 'var(--sipzee-gray-3)', height: '100%', paddingBottom: '10px' }}>
                            <div className={styles.CarouselHeader}>2. Schedule Pick Up </div>
                            <div className={styles.CarouselDescription}>
                                Let us know when your cans and bottles will be available and we will schedule a pick up. Please note - you will need to place your cans and bottles in an area accessible to our returner.
                            </div>
                        </div>
                        <div style={{ backgroundColor: 'var(--sipzee-yellow-2)', height: '100%', paddingBottom: '10px' }}>
                            <div className={styles.CarouselHeader}>3. Confirm Details</div>
                            <div className={styles.CarouselDescription}>
                                Confirm your address, pick how you want to get paid or donate, add special instructions
                            </div>
                        </div>
                        <div style={{ backgroundColor: 'var(--sipzee-green)', height: '100%', paddingBottom:'10px' }}>
                            <div className={styles.CarouselHeader}>4. Get Paid</div>
                            <div className={styles.CarouselDescription}>
                                You will be paid 5&#162; for each can and bottle - sent when the returner pick up is complete. You also have the option to donate your money to local non-profits or fundraisers that have signed up in your area.
                            </div>
                        </div>
                    </Carousel>

                </div>

                <div className={styles.card} >
                    <div style={{ backgroundColor: 'var(--sipzee-gray)' }}>
                        <div style={{ fontSize: '14pt', color: 'white', marginBottom: '10px' }}>
                            How much will I be paid or donate?
                        </div>

                        <Box display="flex"
                            justifyContent="center"
                            alignItems="center"
                            noValidate
                            autoComplete="off">
                            <Image src='/images/Bottle Info Graphic.svg' height={'100%'} width={'100%'} style={{ maxWidth: '500px' }} />
                        </Box>

                    </div>
                </div>
            </div>
            
            <AlertDialog isShown={alertDialog.show} close={() => setAlertDialog({ show: false })} Title={alertDialog.title} Message={alertDialog.message} CloseText={alertDialog.closeButton} />
            <ActiveDonations isShown={showActiveDonationsDialog} onClose={() => setShowActiveDonationsDialog(false) } mode='View' />
            <Snackbar open={snackbar.message !== ''} autoHideDuration={6000} onClose={handleSnackBarClose}>
                <Alert onClose={handleSnackBarClose} severity={snackbar.severity} sx={{ width: '100%' }}>
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </div>
    )
}

export default Home;